/**
 * English labels of the dev performance overlay (W3-03, render/frame/perfOverlay.ts). The overlay is a dev-build
 * tool that runs outside React and the i18n runtime, so it shows this catalogue's English text.
 */

import { catalogOf, defineMessages } from '../../i18n/define';

export const m = defineMessages('perf', {
  title: 'Frame breakdown',
  fps: '{fps} fps',
  frame: 'frame {ms} ms (worst {worst} ms)',
  view: '{name} {ms} ms',
  longTasks: 'long tasks {ms} ms/s',
  idle: 'idle (no frames)',
  preview: 'preview GL submit {cpu} ms, GPU {gpu} ms, scale {scale}, {quads} quads, {w}x{h}',
  none: '-',
});

export default catalogOf(m);
